{
  "actionbar.actions": "Handlinger",
  "actionbar.actionsAvailable": "Tilgængelige handlinger.",
  "actionbar.clearSelection": "Ryd markering",
  "actionbar.selected": "{count, plural, =0 {Ingen valgt} other {# valgt}}",
  "actionbar.selectedAll": "Alle valgt",
  "breadcrumbs.more": "Flere elementer",
  "button.pending": "afventende",
  "combobox.noResults": "Ingen resultater",
  "contextualhelp.help": "Hjælp",
  "contextualhelp.info": "Oplysninger",
  "dialog.alert": "Advarsel",
  "dialog.dismiss": "Luk",
  "dropzone.replaceMessage": "Drop fil for at erstatte",
  "inlinealert.informative": "Oplysninger",
  "inlinealert.negative": "Fejl",
  "inlinealert.notice": "Advarsel",
  "inlinealert.positive": "Fuldført",
  "label.(optional)": "(valgfrit)",
  "label.(required)": "(obligatorisk)",
  "menu.moreActions": "Flere handlinger",
  "notificationbadge.indicatorOnly": "Ny aktivitet",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Vælg…",
  "slider.maximum": "Maksimum",
  "slider.minimum": "Minimum",
  "table.loading": "Indlæser...",
  "table.loadingMore": "Indlæser flere...",
  "table.resizeColumn": "Tilpas størrelse på kolonne",
  "table.sortAscending": "Sorter stigende",
  "table.sortDescending": "Sorter faldende",
  "tag.actions": "Handlinger",
  "tag.hideButtonLabel": "Vis mindre",
  "tag.noTags": "Ingen",
  "tag.showAllButtonLabel": "Vis alle ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
